import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { SignaturePad } from "@/components/phones/SignaturePad";
import { api, errMsg } from "@/lib/api";

export const SignNowDialog = ({ form, onClose, onSigned }) => {
  const [sig, setSig] = useState(null);
  const [busy, setBusy] = useState(false);
  const sign = async () => {
    setBusy(true);
    try { await api.post(`/forms/${form.id}/sign`, { signature: sig }); toast.success("Modulo firmato"); onSigned(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-lg" data-testid="form-sign-dialog">
        <DialogHeader>
          <DialogTitle>Firma · {form.template_name}</DialogTitle>
          <DialogDescription>Fai leggere il testo al driver e fallo firmare col dito o col mouse.</DialogDescription>
        </DialogHeader>
        <p className="rounded-lg bg-slate-50 p-3 text-sm leading-relaxed" data-testid="form-sign-text">{form.text}</p>
        <SignaturePad onChange={setSig} testId="form-signature-pad" />
        <DialogFooter><Button variant="outline" onClick={onClose}>Annulla</Button><Button onClick={sign} disabled={!sig || busy} data-testid="form-sign-confirm">Conferma firma</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
